import { defineComponent as _defineComponent } from 'vue'
import VFooter from "@/components/vFooter.vue";
import DirectSignupForm from "@/components/forms/Signup/DirectSignupForm.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {useRoute, useRouter} from "vue-router/composables";
import {onMounted, ref} from "vue";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import {useStore} from "@/hooks/useStore";
import {FETCH_USER_DETAILS, TRANSLATIONS_FETCH} from "@/store/ActionTypes";
import DirectSignUpVerificationForm from "@/components/forms/Signup/DirectSignUpVerificationForm.vue";
import {useNotify} from "@/hooks/useNotify";
import UserRepository from "@/utils/API/UserRepository";
import SignupDto from "@/models/Restaurants/SignupDto";
import {
  buildSocialBeginUrl,
  clearSocialSignup,
  GOOGLE_PROVIDER,
  handleSocialCallback,
  loadSocialSignup,
  navigateSafely,
  saveSocialSignup,
  SOCIAL_DIRECT_SIGNUP_MODE,
} from "@/utils/socialAuth";
import {SET_AUTH_STATE} from "@/store/MutationTypes";
import {AuthStates} from "@/store/modules/AccountModule";


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectSignup',
  setup(__props) {

const translations = useTranslations();
const route = useRoute();
const router = useRouter();
const store = useStore();
const notify = useNotify();
const isGoogleSignupProcessing = ref(false);
const isVerificationMode = ref(false);
const verificationEmail = ref("");

const selectedPackage = ref<string>();
const recurrence = ref<string>();

onMounted(async() =>{
  await getPackageInfo();
  await store.value.dispatch(TRANSLATIONS_FETCH, {
    category: "pages",
    collections: [
      "common",
      "login",
      "customers",
      "managesubscription",
      "profile",
    ],
  });
  await handleGoogleCallback();
});

async function getPackageInfo() {
  const query = route.query;

  // Check the route's params for a package
  selectedPackage.value = query.package as string;
  // Check the route's params for a recurrence
  recurrence.value = query.freq as string;

  if (!selectedPackage.value || !recurrence.value) return;

  // If the url has a package and recurrence, then the packages are fetched accordingly.
  try {
    const response = await SubscriptionRepository.getByFriendlyName(selectedPackage.value, recurrence.value);
    const packages: Package[] = response.data;
  }
  catch (error) {
    notify.error('Failed to load package information');
  }
}

function handleSignupSuccess(email: string) {
  verificationEmail.value = email;
  isVerificationMode.value = true;
}

function handleVerifiedFailure(msg: string) {
  console.error(msg);
}

function handleGoogleSignupRequested(signup: SignupDto) {
  saveSocialSignup(GOOGLE_PROVIDER, SOCIAL_DIRECT_SIGNUP_MODE, signup);
  window.location.href = buildSocialBeginUrl(GOOGLE_PROVIDER, SOCIAL_DIRECT_SIGNUP_MODE);
}

async function handleGoogleCallback() {
  const completed = await handleSocialCallback({
    provider: GOOGLE_PROVIDER,
    expectedMode: SOCIAL_DIRECT_SIGNUP_MODE,
    router,
    route,
    onProviderError: (message) => notify.error(message),
    onComplete: async (code) => {
      const signup = loadSocialSignup(GOOGLE_PROVIDER, SOCIAL_DIRECT_SIGNUP_MODE);
      if (!signup) {
        notify.error(translations.value.get("google_signup_details_not_found"));
        return false;
      }

      isGoogleSignupProcessing.value = true;
      const response = await UserRepository.completeGoogleSignup({code, signup});
      await store.value.dispatch(FETCH_USER_DETAILS);
      store.value.commit(SET_AUTH_STATE, {
        authState: AuthStates.Success,
        authMessage: response.statusText || "OK",
      });
      return true;
    },
    onFailure: (error: any) => {
      isGoogleSignupProcessing.value = false;
      const message = error.response?.data?.errorMessages?.[0]?.userVisibleMessage
        || translations.value.get("google_signup_failed");
      notify.error(message);
    },
  });

  if (!completed) {
    return;
  }

  clearSocialSignup(GOOGLE_PROVIDER, SOCIAL_DIRECT_SIGNUP_MODE);
  await navigateSafely(router, "/subscription");
}


return { __sfc: true,translations, route, router, store, notify, isGoogleSignupProcessing, isVerificationMode, verificationEmail, selectedPackage, recurrence, getPackageInfo, handleSignupSuccess, handleVerifiedFailure, handleGoogleSignupRequested, handleGoogleCallback, VFooter, DirectSignupForm, DirectSignUpVerificationForm }
}

})